import React, { useContext } from 'react'
import "./CartItem.css"
import { shopContext } from '../../Context/ShopContext'
import remove_icon from '../Assets/minus.png'


console.log("hellow cartitem")
const CartItem = () => {

    const { getTotalCartAmount,all_product, CartItems, removeFromCart } = useContext(shopContext)
    
    return (
        <div className='cartitem'>
            <div className="cart_item_format_main">
                <p>Products</p>
                <p>Title</p>
                <p>Price</p>
                <p>Quantity</p>
                <p>Total</p>
                <p>Remove</p>
            </div>
            <hr />
            { 
                all_product.map((e) => {
                    console.log(CartItems[e.id][0],"eeeeeeeeeeeeeeeeee")
                    if (CartItems[e.id] > 0) {
                        
                        return <div>
                            <div className="cart_item_format cart_item_format_main">
                                <img src={e.image} alt="" className='cart_icon_product_icon' />
                                <p>{e.name}</p>
                                <p>{e.new_price}</p>
                                <button className='cart_item_quantity'>{CartItems[e.id]}</button>
                                <p>{e.new_price* CartItems[e.id]}</p>
                                <img className="cartitem_removeicon" src={remove_icon} alt="" onClick={() => removeFromCart(e.id)} />
                            </div>
                        </div>

                    }
                    return null
                })
            }

            <div className="cartitems_down">
                <div className="cartitems_total">
                    <h1>Cart Totals</h1>
                    <div>
                        <div className="cart_items_total_item">
                            <p>SubTotal</p>
                            <p>{getTotalCartAmount()}</p>
                        </div>
                        <hr/>
                        <div className='cart_items_total_item'>
                            <p>Shopping Fee</p>
                            <p>Free</p>
                        </div>
                        <hr/>
                        <div className='cart_items_total_item'>
                            <h3>Total</h3>
                            <h3>{getTotalCartAmount()}</h3>
                        </div>
                    </div>

                    <button>CheckOut</button>
                </div>
                <div className="cart_item_promocode">
                <p>Enter Promo Code if you have</p>
                <div className='cartItem_promobox'>
                    <input type="text"  placeholder='Enetr Promo Code'/>
                    <button>Submit</button>
                </div>
            </div>
            </div>

            


        </div>
    )
}

export default CartItem